// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type='text'] {\n  -webkit-appearance: none;\n}\n\n.input-number:focus {\n  border: none;\n  outline: none;\n}\n\n.up-arrowsize svg {\n  width: 7px;\n  height: 7px;\n}\n\n.up-arrowsize svg path {\n  fill: #726f7e;\n}\n\n.input-small {\n  height: 26px;\n}\n", ""]);
// Exports
module.exports = exports;
